import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ClothesPage from "../pages/collections/clothes/page";
import ShoesPage from "../pages/collections/shoes/page";
import BagsPage from "../pages/collections/bags/page";
import NailsPage from "../pages/collections/nails/page";
import NewArrivalsPage from "../pages/collections/new-arrivals/page";
import ProductDetailPage from "../pages/products/detail/page";
import EditorialDetailPage from "../pages/editorial/detail/page";
import WishlistPage from "../pages/wishlist/page";
import CheckoutPage from "../pages/checkout/page";
import AdminPage from "../pages/admin/page";
import OrderTrackingPage from "../pages/order-tracking/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/collections/clothes",
    element: <ClothesPage />,
  },
  {
    path: "/collections/shoes",
    element: <ShoesPage />,
  },
  {
    path: "/collections/bags",
    element: <BagsPage />,
  },
  {
    path: "/collections/nails",
    element: <NailsPage />,
  },
  {
    path: "/collections/new-arrivals",
    element: <NewArrivalsPage />,
  },
  {
    path: "/products/:slug",
    element: <ProductDetailPage />,
  },
  {
    path: "/editorial/:slug",
    element: <EditorialDetailPage />,
  },
  {
    path: "/wishlist",
    element: <WishlistPage />,
  },
  {
    path: "/checkout",
    element: <CheckoutPage />,
  },
  {
    path: "/order-tracking",
    element: <OrderTrackingPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
